var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{staticClass:"header"},[(_vm.$vuetify.breakpoint.width > 960)?_c('InternalUserDesktopNav',{attrs:{"showMyUsers":_vm.showMyUsers,"navTabsOptional":_vm.navTabsOptional}}):_c('InternalUserMobileNav',{attrs:{"showMyUsers":_vm.showMyUsers,"navTabsOptional":_vm.navTabsOptional}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }